import { createSlice } from "@reduxjs/toolkit";

const initState = {
  isMenuOpen: true,
  isRightSidebarOpen: false,
  themeMode: "light-mode",
};

const ThemeSlice = createSlice({
  name: "theme",
  initialState: initState,
  reducers: {
    toggleMenu: (state, action) => {
      state.isMenuOpen = action.payload.menuState;
    },
    toggleRightSidebar: (state, action) => {
      state.isRightSidebarOpen = action.payload.rightSidebar;
    },
    toogleThemeMode: (state, action) => {
      state.themeMode = action.payload.mode;
    },
  },
});

export const { toggleMenu, toggleRightSidebar, toogleThemeMode } =
  ThemeSlice.actions;

export default ThemeSlice.reducer;
